import { useEffect } from 'react'
import { addListener } from '@reduxjs/toolkit'
import { useDispatch, useSelector } from 'react-redux'
import { GET_PATIENTS_CHART_SUCCESS, SET_MEDIA_FILE_TAGS_SUCCESS } from '../charts/ChartsConstants'
import {
  ERROR_ACTION,
  GET_MEDIA_FILE_SUCCESS,
  GET_PATIENT_DRUG_SCREEN_INFO_SUCCESS,
  LOAD_ACTION,
  SET_FILE_POP_UP_MEDIA_FILE_TAGS_SUCCESS,
} from './FilePopUpConstants'
import { getFreeDrugRuleLayout } from '../../pages/charts/patient-chart/helper'
import { getStateByAbbreviation } from '../../utils/common'
import { getPatient } from './FilePopUpThunk'
import { getErrorMessage } from './FilePopUpActions'
// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import { getUserFriendlyErrorMessage } from '../../utils/errormessages'

const FilePopUpListener = ({
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  tabId,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  onGetMediaFileSuccess,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  onCloseFilePopUp,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  onSetLoading,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  setToastMessage,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  onUpdateFile,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  patientId,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  fileId,
}) => {
  const dispatch = useDispatch()
  // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
  const settingsPerState = useSelector((state) => state.drugRulesSettingsReducer.settingsPerState)

  useEffect(() => {
    const unsubscribe = dispatch(
      addListener({
        predicate: () => true,
        effect: async (action) => {
          switch (action.type) {
            case LOAD_ACTION:
              onSetLoading(true)
              break
            case GET_MEDIA_FILE_SUCCESS:
              if (action.extraData.tabId === tabId) {
                onSetLoading(false)
                const stateRules = settingsPerState?.find(
                  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
                  (stateSetting) => stateSetting.StateCode === action.extraData.patient.StateCode,
                )
                const patientDrugRules =
                  stateRules?.DrugScreenHtml ||
                  getFreeDrugRuleLayout(getStateByAbbreviation(action.extraData.patient.StateCode))
                onGetMediaFileSuccess(
                  {
                    ...action.payload,
                    patientId: action.extraData.patient.PatientId,
                    patientDrugRules,
                    isFile: action.extraData?.isFile,
                  },
                  action.extraData.patient.PatientId,
                  action.payload.FileId || action.extraData.patient.DrugScreen.FileId,
                )
              }
              break
            case SET_FILE_POP_UP_MEDIA_FILE_TAGS_SUCCESS:
            case SET_MEDIA_FILE_TAGS_SUCCESS:
              if (action.extraData.tabId === tabId && action.type === SET_FILE_POP_UP_MEDIA_FILE_TAGS_SUCCESS) {
                // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
                dispatch(getPatient(patientId, tabId))
              } else if (action.extraData.patientId === patientId && action.payload.data?.FileId === fileId) {
                onUpdateFile(action.payload.data)
              }
              break
            case GET_PATIENTS_CHART_SUCCESS:
            case GET_PATIENT_DRUG_SCREEN_INFO_SUCCESS:
              if (action.extraData.tabId === tabId) {
                onCloseFilePopUp()
                onSetLoading(false)
              } else if (action.extraData.patientId === patientId && action.payload.DrugScreen?.FileId !== fileId) {
                onCloseFilePopUp()
              }
              break
            case ERROR_ACTION:
              console.log(action)
              onSetLoading(false)
              setToastMessage(getErrorMessage(action))
              break
            default:
              break
          }
        },
      }),
    )
    return () => {
      // @ts-expect-error TS2349 -- MIGRATION: not approved, fix when encountered
      if (unsubscribe) unsubscribe()
    }
  }, [patientId, fileId, settingsPerState])

  return null
}

export default FilePopUpListener
